if ($('#modal-sodium-warning').length > 0) {

    setTimeout(function () {
        var sodiumCity = $('#city').val();
        var soiumState = $('#sodiumStateCode').val();
        var sodiumDetails = sodiumCity.split(',');
        var sodiumStateDetails = soiumState.split(',');
        var zipcode = $('.store-container').find(".zip").text();
        var city = orderViewModel.store.city;
        var state = orderViewModel.store.stateProvCode;
        sodiumdisc = sodiumDetails.indexOf(city);
        var warningmodal = sodiumDetails[sodiumdisc];
        for (var i = 0; i < sodiumDetails.length; i++) {
            if (sodiumDetails[i] == city && sodiumStateDetails[i] == state) {
                if (typeof city !== 'undefined' && typeof state !== 'undefined' && warningmodal == city) {
                    modalShowId('#modal-sodium-warning');
                    analytics.sodiumWarningPopUp();
                    //}

                    var postUrl = "/RemoteOrder/ModalPopup/SetSodiumWarningSession";
                    $.ajax({
                        url: postUrl,
                        type: 'POST',
                        contentType: 'application/json; charset=utf-8',
                        success: function (data) {
                            void 0;
                        },
                        error: function (jqXhr) {
                            subwayScript.showAjaxError(jqXhr);
                        }
                    });
                }
                break;
            }
            
        }
        //Passing zipcode value to find the index number
        
    }, 5000);
   
    $('.sodium-popup-btn-txt').click(function () {
        var buttonText = $(this).text();
        analytics.sodiumPopUp(buttonText);
    });
    $('.sodium-popup-btn-close-txt').click(function () {
        analytics.sodiumPopUp("cancel");
    });
}
